module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_max_silver.07175066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_max_silver.png
// module id = 2098
// module chunks = 0